import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Button, TextField, Typography } from '@mui/material';
import DrawerNav from '../DrawerNav/DrawerNav';
import { BASE_URL } from '../../Api/Constants';

export default function EditOnboarding() {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const onboardingId = queryParams.get('id');

    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [imageURL, setImageURL] = useState('');

    useEffect(() => {
        const fetchOnboardingData = async () => {
            try {
                const response = await fetch(`${BASE_URL}/api/onboarding/${onboardingId}`);
                if (response.ok) {
                    const data = await response.json();
                    const { title, description, imageURL } = data.data.onboardingData;
                    setTitle(title);
                    setDescription(description);
                    setImageURL(imageURL);
                } else {
                    console.error('Failed to fetch onboarding data');
                }
            } catch (error) {
                console.error('Error:', error);
            }
        };

        fetchOnboardingData();
    }, [onboardingId]);

    const handleSaveChanges = async () => {
        try {
            const response = await fetch(`${BASE_URL}/api/onboarding/${onboardingId}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    title,
                    description,
                    imageURL,
                }),
            });

            const data = await response.json();

            if (response.ok) {
                console.log(data); // Success message
            } else {
                console.error(data.message); // Error message
            }
        } catch (error) {
            console.error('Error:', error);
        }
    };

    return (
        <Box sx={{ display: 'flex' }}>
            <DrawerNav />
            <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
                <Box p={2}>
                    <Typography variant="h4" sx={{ my: 2, fontWeight: 'bolder', color: '#4b4848' }}>
                        Edit Onboarding Screen
                    </Typography>
                    <TextField
                        label="Title"
                        value={title}
                        onChange={(event) => setTitle(event.target.value)}
                        fullWidth
                        variant="outlined"
                        margin="normal"
                    />
                    <TextField
                        label="Description"
                        value={description}
                        onChange={(event) => setDescription(event.target.value)}
                        fullWidth
                        variant="outlined"
                        margin="normal"
                        multiline
                        rows={4}
                    />
                    <TextField
                        label="Image URL"
                        value={imageURL}
                        onChange={(event) => setImageURL(event.target.value)}
                        fullWidth
                        variant="outlined"
                        margin="normal"
                    />
                    <Box mt={2}>
                        <Button variant="contained" color="primary" onClick={handleSaveChanges}>
                            Save Changes
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}
